import { FilterDTO } from './filter.dto';

export class AreaSearchListDTO {
  constructor(public readonly reportFilter: FilterDTO,
              public readonly parentCode?: string) {
  }
}
